import { effect, inject, Injectable } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { WebSocketService } from '@services/web-socket.service';
import { TopicType } from '../enums/topic-type';
import { DataStore } from '@stores/data.store';

@Injectable({
  providedIn: 'root',
})
export class FinPingService {
  private authService = inject(AuthService);
  private webSocketService = inject(WebSocketService);
  private dataStore = inject(DataStore);
  private uuid = this.webSocketService.uuid;
  locale = this.dataStore.locale;
  private pingIntervalId?: ReturnType<typeof setInterval>;

  constructor() {
    effect(() => {
      const user = this.authService.user();
      const token = user?.token?.authToken;
      if (token) {
        this.startPeriodicPing();
      } else {
        this.stopPeriodicPing();
      }
    });
  }

  sendFinPingRequest() {
    const user = this.authService.user();
    if (!user?.username || !user.token?.authToken) {
      return;
    }
    const username = user.username;
    const token = user.token.authToken;
    const message: object = {
      username,
      key: this.uuid,
      token,
    };
    this.webSocketService.send({ topic: TopicType.FIN_PING_REQUEST, message });
  }

  private startPeriodicPing(): void {
    const hasToken = !!this.authService.user().token?.authToken;
    if (!hasToken || this.pingIntervalId) {
      return;
    }

    const PING_INTERVAL = 3600000;

    if (!sessionStorage.getItem('finPingTimer')) {
      sessionStorage.setItem('finPingTimer', JSON.stringify(new Date()));
    }

    this.pingIntervalId = setInterval(() => {
      const lastPingTime = sessionStorage.getItem('finPingTimer');

      if (!lastPingTime) {
        sessionStorage.setItem('finPingTimer', JSON.stringify(new Date()));
        return;
      }

      let lastPing = 0;
      try {
        lastPing = new Date(JSON.parse(lastPingTime)).getTime();
      } catch {
        lastPing = Date.now();
      }

      const now = Date.now();
      const timePassed = now - lastPing;

      if (timePassed >= PING_INTERVAL) {
        this.sendFinPingRequest();
        sessionStorage.setItem('finPingTimer', JSON.stringify(new Date()));
      }
    }, 600000);
  }

  private stopPeriodicPing(): void {
    if (this.pingIntervalId) {
      clearInterval(this.pingIntervalId);
      this.pingIntervalId = undefined;
    }
  }
}
